import Button from "@mui/material/Button";
import {
  Stack,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";

import { FieldInputText, FieldSelect } from "../../../../../components/Fields";

import "../../styles.css";

export default function PainelSensibilidade({
  handleChangePanel,
  onSubmit,
  data,
  setData,
  simOuNaoOptions,
  avaliacaoSegmentarOptions,
  disfuncaoAutonomicaOptions,
  handleCheckedField,
}) {
  function handleSetData(value, field) {
    if (field === "disfuncaoAutonomica" && value === "51") {
      setData((prevState) => ({
        ...prevState,
        disfuncaoAutonomica: value,
        tipoDisfuncao: [],
      }));
    } else {
      setData((prevState) => ({
        ...prevState,
        [field]: value,
      }));
    }
  }

  return (
    <form autoComplete="off" onSubmit={onSubmit}>
      <Stack className="templateGridForm">
        <Stack>
          <Stack direction="row" className="labelText">
            Parestesias:
          </Stack>
          <RadioGroup
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
            }}
          >
            {simOuNaoOptions.map(({ key, value }) => {
              return (
                <FormControlLabel
                  value={value}
                  control={<Radio />}
                  label={key}
                  key={value}
                  checked={data.parestesias === value}
                  onChange={(e) => handleSetData(e.target.value, "parestesias")}
                />
              );
            })}
          </RadioGroup>
        </Stack>
        <Stack>
          <Stack direction="row" className="labelText">
            Disestesias:
          </Stack>
          <RadioGroup
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
            }}
          >
            {simOuNaoOptions.map(({ key, value }) => {
              return (
                <FormControlLabel
                  value={value}
                  control={<Radio />}
                  label={key}
                  key={value}
                  checked={data.disestesias === value}
                  onChange={(e) => handleSetData(e.target.value, "disestesias")}
                />
              );
            })}
          </RadioGroup>
        </Stack>
        <Stack>
          <Stack direction="row" className="labelText">
            Alodinia:
          </Stack>
          <RadioGroup
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
            }}
          >
            {simOuNaoOptions.map(({ key, value }) => {
              return (
                <FormControlLabel
                  value={value}
                  control={<Radio />}
                  label={key}
                  key={value}
                  checked={data.alodinia === value}
                  onChange={(e) => handleSetData(e.target.value, "alodinia")}
                />
              );
            })}
          </RadioGroup>
        </Stack>
      </Stack>

      <Stack component="h2" className="titleSection">
        Avaliação segmentar
      </Stack>

      <Stack component="h2" className="subTitleSection">
        MID Proximal
      </Stack>
      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MIDProximalVibratoria}
          setValue={(value) => handleSetData(value, "MIDProximalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MIDProximalCinetPost}
          setValue={(value) => handleSetData(value, "MIDProximalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MIDProximalTactil}
          setValue={(value) => handleSetData(value, "MIDProximalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MIDProximalDor}
          setValue={(value) => handleSetData(value, "MIDProximalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>
      <Stack component="h2" className="subTitleSection">
        MID Distal
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MIDDistalVibratoria}
          setValue={(value) => handleSetData(value, "MIDDistalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MIDDistalCinetPost}
          setValue={(value) => handleSetData(value, "MIDDistalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MIDDistalTactil}
          setValue={(value) => handleSetData(value, "MIDDistalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MIDDistalDor}
          setValue={(value) => handleSetData(value, "MIDDistalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack component="h2" className="subTitleSection">
        MIE Proximal
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MIEProximalVibratoria}
          setValue={(value) => handleSetData(value, "MIEProximalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MIEProximalCinetPost}
          setValue={(value) => handleSetData(value, "MIEProximalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MIEProximalTactil}
          setValue={(value) => handleSetData(value, "MIEProximalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MIEProximalDor}
          setValue={(value) => handleSetData(value, "MIEProximalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack component="h2" className="subTitleSection">
        MIE Distal
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MIEDistalVibratoria}
          setValue={(value) => handleSetData(value, "MIEDistalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MIEDistalCinetPost}
          setValue={(value) => handleSetData(value, "MIEDistalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MIEDistalTactil}
          setValue={(value) => handleSetData(value, "MIEDistalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MIEDistalDor}
          setValue={(value) => handleSetData(value, "MIEDistalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack component="h2" className="subTitleSection">
        MSD Proximal
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MSDProximalVibratoria}
          setValue={(value) => handleSetData(value, "MSDProximalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MSDProximalCinetPost}
          setValue={(value) => handleSetData(value, "MSDProximalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MSDProximalTactil}
          setValue={(value) => handleSetData(value, "MSDProximalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MSDProximalDor}
          setValue={(value) => handleSetData(value, "MSDProximalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack component="h2" className="subTitleSection">
        MSD Distal
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MSDDistalVibratoria}
          setValue={(value) => handleSetData(value, "MSDDistalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MSDDistalCinetPost}
          setValue={(value) => handleSetData(value, "MSDDistalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MSDDistalTactil}
          setValue={(value) => handleSetData(value, "MSDDistalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MSDDistalDor}
          setValue={(value) => handleSetData(value, "MSDDistalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack component="h2" className="subTitleSection">
        MSE Proximal
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MSEProximalVibratoria}
          setValue={(value) => handleSetData(value, "MSEProximalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MSEProximalCinetPost}
          setValue={(value) => handleSetData(value, "MSEProximalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MSEProximalTactil}
          setValue={(value) => handleSetData(value, "MSEProximalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MSEProximalDor}
          setValue={(value) => handleSetData(value, "MSEProximalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack component="h2" className="subTitleSection">
        MSE Distal
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Vibratória"
          value={data.MSEDistalVibratoria}
          setValue={(value) => handleSetData(value, "MSEDistalVibratoria")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Cinet-post"
          value={data.MSEDistalCinetPost}
          setValue={(value) => handleSetData(value, "MSEDistalCinetPost")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Táctil"
          value={data.MSEDistalTactil}
          setValue={(value) => handleSetData(value, "MSEDistalTactil")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Dor"
          value={data.MSEDistalDor}
          setValue={(value) => handleSetData(value, "MSEDistalDor")}
          items={avaliacaoSegmentarOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack direction="row" className="labelText">
        Disfunção autonômica
      </Stack>

      <Stack>
        <RadioGroup row>
          {simOuNaoOptions.map(({ key, value }) => {
            return (
              <FormControlLabel
                value={value}
                control={<Radio />}
                label={key}
                checked={data.disfuncaoAutonomica === value}
                onChange={(e) =>
                  handleSetData(e.target.value, "disfuncaoAutonomica")
                }
              />
            );
          })}
        </RadioGroup>
        {data.disfuncaoAutonomica === "50" && (
          <>
            <FormGroup className="templateGridFormCheckbox CheckboxColor">
              {disfuncaoAutonomicaOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Checkbox />}
                    label={key}
                    onClick={(e) => handleCheckedField(e, "tipoDisfuncao")}
                    checked={data.tipoDisfuncao.includes(value)}
                  />
                );
              })}
            </FormGroup>
            {data.tipoDisfuncao.includes("118") && (
              <Stack className="templateGridForm">
                <FieldInputText
                  label=""
                  value={data.disfuncaoAutonomicaOutra}
                  setValue={(value) =>
                    handleSetData(value, "disfuncaoAutonomicaOutra")
                  }
                  placeholder="Outros"
                />
                <Stack></Stack>
                <Stack></Stack>
                <Stack></Stack>
              </Stack>
            )}
          </>
        )}
      </Stack>

      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 3,
        }}
      >
        <Button className="buttonText cancel" variant="outlined">
          Cancelar
        </Button>
        <Button
          className="buttonText submit"
          variant="contained"
          onClick={handleChangePanel("all")}
          type="submit"
          name="sensibilidade"
        >
          Salvar
        </Button>
      </Stack>
    </form>
  );
}
